import { create } from "zustand";
import { persist } from "zustand/middleware";

// Tipagem para o estado da store
export type DraftState<T> = {
  draft: T;
  setDraft: (draft: T) => void;
  clearDraft: () => void;
};

export const useDraftStore = <T extends object>({ key }: { key?: string }) => {
  return create<DraftState<T>>()(
    persist(
      (set) => ({
        draft: {} as T,
        setDraft: (draft) => set({ draft }),
        clearDraft: () => set({ draft: {} as T }),
      }),
      {
        name: `${key ? `${key}-` : ""}draft-storage`,
        storage: {
          getItem: (key: string) => {
            const stored = localStorage.getItem(key);
            return stored ? JSON.parse(stored) : null;
          },

          setItem: (key: string, value: any) => {
            localStorage.setItem(key, JSON.stringify(value));
          },
          removeItem: (key: string) => {
            localStorage.removeItem(key);
          },
        },
      }
    )
  );
};
